package one.healthium.fodmap

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://fodmap-content-stage.web.app/"
                Flavour.Prod -> "https://fodmap-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "FODMAP",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> ""
            Flavour.Prod -> ""
        },
        adaptyKey = "public_live_D33MLvmb.j77IDjk58UZpo8psZxlY",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6743630566",
        feedbackEmail = "fodmap@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:525248621849:android:073bbf477bbc8a7f3ea988",
                apiKey = "AIzaSyC2c-raddOAsF7ADG8mQTsEV6lUPp5MpcI",
                projectId = "ibs-fodmap-app-stage",
                storageBucket = "ibs-fodmap-app-stage.firebasestorage.app",
                userStorageBucket = "gs://ibs-fodmap-app-stage-users-data",
                authDomain = "ibs-fodmap-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:702723791040:android:f1da47860aebddf1893525",
                apiKey = "AIzaSyC7ncHjk7wsPW_FVQftGHSyP6adXAPn2C0",
                projectId = "ibs-fodmap-app-prod",
                storageBucket = "ibs-fodmap-app-prod.firebasestorage.app",
                userStorageBucket = "gs://ibs-fodmap-app-prod-users-data",
                authDomain = "ibs-fodmap-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "fodmap_stage"
            Flavour.Prod -> "fodmap"
        },
        oneLinkBaseUrl = "https://hltm-fodmap.onelink.me/6O0f/web",
    )

